var $ = require('../internals/export');

// `Date.now` method
// https://tc39.github.io/ecma262/#sec-date.now
$({ target: 'Date', stat: true }, {
  now: function now() {
    return new Date().getTime();
  }
});



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/core-js-pure/modules/es.date.now.js
// module id = 2783
// module chunks = 1